/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfAccountingV1AccountEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_ACCOUNTING_V1_ACCOUNT_EVENT_ENTITY_NAME = 'ixf.accounting.v1.AccountEvent';
export const ixfAccountingV1AccountEventEntity = new schema.Entity<IxfAccountingV1AccountEvent>(IXF_ACCOUNTING_V1_ACCOUNT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfAccountingV1AccountEvent) => `${entity.metadata?.eventId}` });

